import store from "@/store";
import { ShakenStorage } from "@/service/storage";
export class FunctionSettingService {

  constructor() {
  }

  private valid() {
    const authContext = ShakenStorage.getActiveAuth();
    const groupCd: any = authContext && authContext.groupCd;
    const shatenCd: any = authContext && authContext.shatenCd;
    const kyotenCd: any = authContext && authContext.kyotenCd;
    const functionSetting = store.getters["FunctionSetting/currentState"];

    return ( groupCd && groupCd == functionSetting.groupCd
      && shatenCd && shatenCd == functionSetting.shatenCd
      && kyotenCd && kyotenCd == functionSetting.kyotenCd
    );
  }

  public isDebug() {
    const functionSetting = store.getters["FunctionSetting/currentState"];
    return this.valid && functionSetting && functionSetting.isDebug == "1";
  }
}

